<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">CGU</div>
        <div class="modal-body">

            <div class="pre-cgu-message">Veuillez accepter les CGU pour pouvoir accéder aux services Hypermed.</div>

            <iframe #cguIframe class="cgu-display" [src]="cguPdf" width="100%" height="600px"></iframe>

            <div class="buttons-wrapper">
                <frg-button class="btn btn-secondary" (activated)="refuseCgu()" [backgroundColor]="'var(--danger)'">Refuser</frg-button>
                <frg-button class="btn btn-primary" (activated)="acceptCgu()">Accepter</frg-button>
            </div>

        </div>
    </div>

    <!-- Loader -->
    <ng-container *ngIf="isLoading || !cguPdf">
        <div class="loading-container">
            <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </ng-container>
</div>
<div class="modal-background"></div>